export default [
  {
    path: '/main/frota/drivers',
    meta: {
      tag: 'list_frota_drivers',
      name: 'Motoristas',
      breadcrumb: 'Motoristas'
    },
    component: () => import(/* webpackChunkName: "frota-drivers-list" */ '@/views/main/settings/frota/driver/Index.vue'),
    children: [
      {
        path: '',
        name: 'listfrotadriver',
        meta: {
          tag: 'list_frota_drivers',
          menu: 'settings',
          name: 'Motoristas'
        },
        component: () => import(/* webpackChunkName: "frota-drivers-list" */ '@/views/main/settings/frota/driver/List.vue'),
      }
    ]
  }
]
